import styled from 'styled-components'

export const GridLine = styled.div.attrs(({ ...rest }: React.CSSProperties) => ({
  style: { ...rest }
}))<React.CSSProperties>`
  position: relative;
  padding-left: 0.5rem;
  width: 100%;
  display: grid;
  grid-template-columns: minmax(150px, 200px) 170px repeat(6, 1fr);
`

export const GridCell = styled.div.attrs(({ ...rest }: React.CSSProperties) => ({
  style: { ...rest }
}))<React.CSSProperties>`
  position: relative;
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  border: 1px solid ${props => props.theme.colors.colordfe3e8};
`

export const GridRefCell = styled.div`
  position: relative;
  color: ${props => props.theme.colors.color122d52};
  text-align: center;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  background: ${props => props.theme.colors.colorf3f5f9};
`

export const PropertyContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: column;
  margin-bottom: 1.5rem;
`

export const PropertyAccordion = styled.button`
  position: relative;
  width: 100%;
  border-radius: 4px 0px 4px 4px;
  background: ${props => props.theme.colors.colore4e8ef};
  padding: 0 0.5rem;
  border: none;
  cursor: pointer;

  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    color: ${props => props.theme.colors.color122d52};
    width: 14px;
  }

  &:hover {
    background: ${props => props.theme.colors.colordfe3e8};
  }
`

export const PropertyTitle = styled.h3`
  text-align: left;
  color: ${props => props.theme.colors.color122d52};
  font-family: 'Inter';
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
`
